const Banner = '/assets/jm/BusesJM-WebDesign-Slide-MainBanner.jpg';
const headphone = '/assets/jm/BusesJM-WebDesign-Header-ContactButtom.svg';

const BookingInActive = '/assets/jm/BusesJM-WebDesign-SearchBar-BuyTicket-Off.svg';
const BookingActive = '/assets/jm/BusesJM-WebDesign-SearchBar-BuyTicket-On.svg';
const CancelInActive = '/assets/jm/BusesJM-WebDesign-SearchBar-CancelTicket-Off.svg';
const CancelActive = '/assets/jm/BusesJM-WebDesign-SearchBar-CancelTicket-On.svg';
const cuponeraInActive = '/assets/jm/BusesJM-WebDesign-SearchBar-Cuponera-Off.svg';
const cuponeraActive = '/assets/jm/BusesJM-WebDesign-SearchBar-Cuponera-On.svg';

// couponera tab icons
const ConfirmInActive = '/assets/jm/Confirmar white.svg';
const ConfirmActive = '/assets/jm/Confirmar color.svg';
const CouponInActive = '/assets/jm/Cuponera white.svg';
const CouponActive = '/assets/jm/Cuponera color.svg';

const OriginIcon = '/assets/jm/BusesJM-WebDesign-SearchBar-Origin.svg';
const DestinationIcon = '/assets/jm/BusesJM-WebDesign-SearchBar-Destination.svg';
const CalendarIcon = '/assets/jm/BusesJM-WebDesign-SearchBar-Calendar.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/jm/BusesJM-Website-Home-WhereToFindMyPNR.svg';

const close = '/assets/jm/BusesJM-WebDesign-SearchBar-XMark.svg';

// const success = '/static/images/icons/circular-icons/icon-success.png';
// const failure = '/static/images/icons/circular-icons/icon-success.png';
const SearchIcon = '/assets/andimar/navbar-searchIcon.svg';
const contactUsBanner = '/assets/jm/BusesJM-WebDesign-ContactBanner.jpg';

const success = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess =
  '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

const paso_1 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const paso_2 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargePoints-Orange.svg';
const paso_3 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ID-Orange.svg';
const paso_4 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tickets-Orange.svg';
const operatorPay = '/assets/jm/JMPay.svg';

const busesjmIcons = [
  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: paso_1, name: 'paso_1' },
  { icon: paso_2, name: 'paso_2' },
  { icon: paso_3, name: 'paso_3' },
  { icon: paso_4, name: 'paso_4' },

  { icon: Banner, name: 'Banner' },
  { icon: headphone, name: 'headphone' },

  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },

  { icon: contactUsBanner, name: 'contactUsBanner' },
  // { icon: HeaderLogo, name: 'headerLogo' },
  // { icon: FooterLogo, name: 'footerLogo' },

  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: CalendarIcon, name: 'Calendar' },

  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },
  { icon: cuponeraInActive, name: 'CUIA' },
  { icon: cuponeraActive, name: 'CUA' },

  { icon: ConfirmInActive, name: 'ConfirmIA' },
  { icon: ConfirmActive, name: 'ConfirmA' },
  { icon: CouponInActive, name: 'CouponIA' },
  { icon: CouponActive, name: 'CouponA' },
  // { icon: PopupIcon, name: 'Popup' },

  { icon: animation, name: 'animation' },
  { icon: checkboxIcon, name: 'Checkbox' },

  { icon: pnr, name: 'pnr' },
  { icon: close, name: 'close' },
  { icon: operatorPay, name: 'operatorPay' },
  { icon: SearchIcon, name: 'Search' },

];

export default busesjmIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/busesjmIcons.js